import * as React from 'react';

import * as styles from './styles.css';

export const LayoutServices: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="LayoutServices" className={styles['container']}>
      {children}
    </div>
  );
};

LayoutServices.displayName = 'LayoutServices';
